import { env } from "."

/* Components */
import { Picture, Chip } from '../components'

/* Fields */
const chips = [
    { value: 1, color: "#f44336" },
    { value: 5, color: "#8bc34a" },
    { value: 25, color: "#2196f3" },
    { value: 100, color: "#ff9800" },
    { value: 500, color: "#673ab7" },
    { value: 1000, color: "#222222" },
]


const ru = [
    {
        id: 1,
        title: 'Правила игры',
        text: '',
        content:
            <div className="rule-content">

                <p>
                    <b>БЛЕК ДЖЕК</b>
                    <br /><br />
                    Блек Джек – очень простая и захватывающая игра. Цель игры набрать наиболее близкое к 21 количество очков.  Игрок делает ставки на обозначенную на столе позицию (Bet) в пределах минимума и максимума стола.
                </p>

                <p>После того, как ставки сделаны игрок получает две карты, у дилера также две карты, одна из которых закрыта. Все картинки оцениваются в 10 очков, Туз – 11 или 1 очко, остальные карты оцениваются по их номиналу. На основании полученных карт игрок принимает решение, брать дополнительные карты или остановиться.  Если сумма очков игрока превышает 21, то он проигрывает. Игрок не может взять карту, если сумма очков на боксе составляет 21.</p>

                <p>После того, как игрок принял решение, дилер набирает карты себе. Дилер продолжает набирать карты на 16 и меньше и останавливается на 17 и больше. Если общая сумма очков игрока превышает сумму очков дилера, но не больше 21, он выигрывает, и наоборот. Если игрок и дилер набирают равное количество очков, объявляется Ничья «Stand off» (никто не выигрывает и не проигрывает).</p>

                <p>«Блек Джек» – комбинация из туза и карты достоинством 10 очков на первых двух картах; сразу оплачивается 3:2, кроме случаев, когда  карта дилера – туз или карта достоинством 10 очков. Все остальные выигравшие комбинации оплачиваются 1:1.</p>

                <p>«Блек Джек» – самая старшая комбинация. «Блек Джек» никогда не проигрывает. Если у дилера и игрока «Блек Джек» – возникает ситуация «Stand off».</p>

                <p style={{ fontWeight: 700 }}>Double (Удвоение)</p>
                <p>
                    Имея любую сумму очков на первых двух картах, кроме «Блек Джек», вы можете удвоить свою ставку. После этого вы можете получить только одну карту независимо от ее достоинства. Рискуйте, и двойной выигрыш – Ваш!
                </p>

                <p style={{ fontWeight: 700 }}>Split (Разделение)</p>
                <p>
                    Если первые две карты игрока имеют одинаковое достоинство, то он может сделать «Split» - разделить две карты, доставив при этом ставку, равную первоначальной, и набирать карты на каждую из них отдельно.
                    При сплите Тузов на каждый Туз дается только по одной карте. Когда на Туз после разделения приходит десятка, это не является комбинацией «Блек Джек», а считается как «21».
                </p>

                <p style={{ fontWeight: 700 }}>SURRENDER (Отказ от игры)</p>
                <p>
                    Surrender – право сдаться – возможно после раздачи первых двух карт. Если игрок принимает решение отказаться от игры, он теряет половину ставки и возможность продолжать игру. При тузе у дилера Surrender нет.
                </p>

                <p style={{ fontWeight: 700 }}>Страхование</p>
                <p>
                    Если карта дилера – Туз, игрок может застраховаться от комбинации «Блек Джек» у дилера, поставив дополнительную ставку в размере половины от первоначальной ставки.
                </p>
                <p>«Блек Джек» игрока не страхуется.</p>

                <p>Если у дилера «Блек Джек», то страховка оплачивается 2:1, в противном случае она проигрывает.</p>

                <p>Таблица выплат</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>BEST HAND</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>СТРАХОВКА</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>BLACKJACK</td>
                            <td>3:2</td>
                        </tr>
                    </tbody>
                </table>

            </div>
    },
    {
        id: 3,
        title: 'Дополнительные ставки',
        type: "additional",
        content:
            <div className="rule-content">
                <br />
                <p style={{ fontWeight: 700 }}>21+3</p>
                <p>Дополнительная ставка «21+3» выигрывает, если с первых двух карт игрока и открытой карты дилера образовывается три карты одного номинала одной масти, либо три карты подряд одной масти, либо три карты одного номинала, либо три карты подряд, либо три карты одной масти и оплачивается в соответствии с таблицей выплат.</p>

                <p>Таблица выплат для 21+3</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>SUITED TRIPS</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>СТРИТ ФЛЭШ</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>ТРОЙКА</td>
                            <td>30:1</td>
                        </tr>
                        <tr>
                            <td>СТРИТ</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>ФЛЭШ</td>
                            <td>5:1</td>
                        </tr>

                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Perfect Pair</p>
                <p>Дополнительная ставка «Perfect Pair» выигрывает, если первые две карты игрока одного номинала и одной масти, либо одного номинала и одного цвета, либо одного номинала и оплачивается в соответствии с таблицей выплат.</p>

                <p>Таблица выплат для Perfect Pair</p>
                <table className="rules-table">
                    <tbody>

                        <tr>
                            <td>PERFECT PAIR</td>
                            <td>25:1</td>
                        </tr>
                        <tr>
                            <td>COLOURED PAIR</td>
                            <td>12:1</td>
                        </tr>
                        <tr>
                            <td>MIXED PAIR</td>
                            <td>6:1</td>
                        </tr>

                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Bust Bonus</p>
                <p>Дополнительная ставка на то, что у дилера обязательно будет перебор. Выигрыш зависит от того, с какого количества карт будет перебор у дилера и оплачивается в соответствии с таблицей выплат. Если у игрока Блэк Джэк, то ставка на Bust Bonus возвращается.</p>

                <p>Таблица выплат для Bust Bonus</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>BUST WITH 8+ CARDS</td>
                            <td>250:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 7 CARDS</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 6 CARDS</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 5 CARDS</td>
                            <td>9:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 4 CARDS</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 3 CARDS</td>
                            <td>1:1</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}> Crazy 7</p>
                <p>Дополнительная ставка на то, что игроку первой, а за тем второй и третьей картой будут розданы «Семерки». Если после «Split» семерок следующая карта семерка, то у вас три семерки. Ставка оплачивается в соответствии с таблицей выплат.</p>
                <p>Таблица выплат для Bust Bonus</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>7-7-7 SUITED</td>
                            <td>2000:1</td>
                        </tr>
                        <tr>
                            <td>7-7-7</td>
                            <td>500:1</td>
                        </tr>
                        <tr>
                            <td>7-7 SUITED</td>
                            <td>150:1</td>
                        </tr>
                        <tr>
                            <td>7-7</td>
                            <td>25:1</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>5:1</td>
                        </tr>
                    </tbody>
                </table>
            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="rule-content">

                <p>Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.</p>

                <div className="rule-component">
                    <div className="game-info-inner">
                        <div className="game-info-text">BLACKJACK ONE</div>
                        <div className="game-info-rate">$ 1 - $ 1000</div>
                    </div>
                </div>

                <p>Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text">БАЛАНС:</div>
                        <div className="balance-value">$ 1 270</div>
                    </div>
                </div>

                <p>Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.</p>
                <div className="rule-component">
                    <div className="chips-container" style={{ transform: 'scale(0.4)' }}>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                            Очистить
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                            Отменить
                        </div>

                        <div className="chips-box">
                            {chips.map((chip, index) =>
                                <div key={`${index}`} className="chip">
                                    <Chip color={chip.color} value={chip.value} />
                                </div>
                            )}
                        </div>

                        <div className="chips-button">
                            <span>2x</span>
                            Удвоить
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                            Повторить
                        </div>

                    </div>
                </div>


                <p>После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.</p>
                <div className="rule-component">
                    <div className="rates history" style={{ position: "relative", top: 0, bottom: 0 }} >
                        <div className={`game-rate-block additional-rate-last`}>
                            <div className="game-rate">
                                <div className="game-rate-text" style={{ fontSize: 15 }}>BUST</div>
                            </div>
                        </div>
                        <div className={`game-rate-block additional-rate`}>
                            <div className="game-rate">
                                <div className="game-rate-text" style={{ fontSize: 16 }}>21+3</div>
                            </div>
                        </div>
                        <div className={`game-rate-block`}>
                            <div className="game-rate">
                                <div className="game-rate-text" style={{ fontSize: 15 }}>BET</div>
                            </div>
                        </div>
                        <div className={`game-rate-block additional-rate`}>
                            <div className="game-rate">
                                <div className="game-rate-text" style={{ fontSize: 11.5 }}>PERFECT PAIRS</div>
                            </div>
                        </div>
                        <div className={`game-rate-block additional-rate-last`}>
                            <div className="game-rate">
                                <div className="game-rate-text" style={{ fontSize: 12 }}>CRAZY SEVEN</div>
                            </div>
                        </div>
                    </div>
                </div>

                <p>ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.</p>

                <p>Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                        Повторить
                    </div>
                </div>

                <p>Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <span>2x</span>
                        Удвоить
                    </div>
                </div>

                <p>Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.</p>
                <p>Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                        Отменить
                    </div>
                </div>

                <p>Кнопка «ОЧИСТИТЬ» позволяет удалить все размещенные ставки.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                        Очистить
                    </div>
                </div>

                <p>Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text blue">ОБЩЯЯ СТАВКА:</div>
                        <div className="balance-value">$ 270</div>
                    </div>
                </div>

                <p>Примите решение</p>
                <p>После раздачи ваших карт появится ваша комбинация карт и окно</p>
                <div className="rule-component">
                    <Picture src={`${env.endpoint}/images/game.png`} alt="Game" />
                </div>

                <p>При нажатии появится окно «Страховка»</p>
                <div className="rule-component">
                    <Picture src={`${env.endpoint}/images/insurance.png`} alt="Insurance" />
                </div>
            </div>
    },
    {
        id: 5,
        title: 'Номер игры',
        content:
            <div className="rule-content">
                <p>Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.</p>
                <div className="rule-component">
                    <p><b>#47489</b></p>
                </div>
                <p>Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.</p>
            </div>
    },
    {
        id: 6,
        title: 'Звук',
        content:
            <div className="rule-content">
                <p>Кнопка «ЗВУК» включает/выключает все звуки игры и голоса. Примите к сведению, что в случае смены стола все звуки включатся автоматически.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/music-on.png`} alt="Volume" />
                    </div>
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/volume.png`} alt="Volume" />
                    </div>
                </div>

                <p>Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК.</p>
            </div>
    },
    {
        id: 7,
        title: 'История игр',
        content:
            <div className="rule-content">
                <p>С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/history.png`} alt="History" />
                    </div>
                </div>

                <p>Вы можете просматривать свою игровую активность с помощью следующего:</p>
                <p>• ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.</p>
                <p>Последний завершенный раунд отображается в самом верху списка.</p>
                <p>• ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.</p>
            </div>
    },
    {
        id: 8,
        title: 'Действия в случае сбоя',
        content:
            <div className="rule-content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно 2
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 9,
        title: 'Политика отключения',
        content:
            <div className="rule-content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]



const en = [
    {
        id: 1,
        title: 'Game Rules',
        text: "",
        content:
            <div className="rule-content">

                <p>
                    <b>BLACKJACK</b>
                    <br /><br />
                    Blackjack is a very simple and exciting game. The goal of the game is to get as close to 21 points as possible. The player places bets on the designated position on the table (Bet) within the table's minimum and maximum limits.
                </p>

                <p>After the bets are placed, the player receives two cards, and the dealer also receives two cards, one of which is face down. All face cards are valued at 10 points, an Ace is worth either 11 or 1 point, and all other cards are valued according to their rank. Based on the received cards, the player decides whether to take additional cards or stop. If the player's total exceeds 21, they lose. The player cannot take a card if their total is 21.</p>

                <p>Once the player has made their decision, the dealer draws cards. The dealer must draw on 16 or less and stands on 17 or more. If the player's total exceeds the dealer’s total without going over 21, the player wins, and vice versa. If the player and dealer have the same total, it is a "Stand Off" (a tie, where no one wins or loses).</p>

                <p>"Blackjack" is a combination of an Ace and a 10-point card in the first two cards; it pays immediately at 3:2, except when the dealer's face-up card is an Ace or a 10-point card. All other winning hands are paid 1:1.</p>

                <p>"Blackjack" is the highest-ranking combination. A Blackjack never loses. If both the dealer and the player have Blackjack, the result is a "Stand Off."</p>

                <p style={{ fontWeight: 700 }}>Double</p>
                <p>
                    With any two-card total except Blackjack, you can double your bet. After doing so, you can receive only one more card, regardless of its value. Take the risk, and a double win could be yours!
                </p>

                <p style={{ fontWeight: 700 }}>Split</p>
                <p>
                    If the player's first two cards have the same value, they can choose to "Split"—separating the cards into two hands by placing an additional bet equal to the original bet. Each hand is then played separately.
                    When splitting Aces, each Ace receives only one additional card. If a 10-value card is drawn on a split Ace, it is counted as "21" and not Blackjack.
                </p>

                <p style={{ fontWeight: 700 }}>SURRENDER (Give Up)</p>
                <p>
                    Surrender – the right to give up – is possible after the first two cards are dealt. If the player decides to surrender, they lose half of their bet and the opportunity to continue playing. Surrender is not available if the dealer has an Ace.
                </p>


                <p style={{ fontWeight: 700 }}>Insurance</p>
                <p>
                    If the dealer's face-up card is an Ace, the player can insure against the dealer having Blackjack by placing an additional bet equal to half of their original bet.
                </p>
                <p>A player's Blackjack cannot be insured.</p>

                <p>If the dealer has Blackjack, the insurance bet pays 2:1; otherwise, the insurance bet is lost.</p>

                <p>Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>BEST HAND</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>INSURANCE</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>BLACKJACK</td>
                            <td>3:2</td>
                        </tr>
                    </tbody>
                </table>

            </div>


    },
    {
        id: 3,
        title: 'Additional bets',
        type: "additional",
        content:
            <div className="rule-content">
                <br />
                <p style={{ fontWeight: 700 }}>21+3</p>
                <p>The additional "21+3" bet wins if the player's first two cards and the dealer's upcard form a suited three-of-a-kind, a straight flush, a three-of-a-kind, a straight, or a flush. Payouts are based on the paytable.</p>

                <p>21+3 Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>SUITED TRIPS</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>STRAIGHT FLUSH</td>
                            <td>40:1</td>
                        </tr>
                        <tr>
                            <td>THREE OF A KIND</td>
                            <td>30:1</td>
                        </tr>
                        <tr>
                            <td>STRAIGHT</td>
                            <td>10:1</td>
                        </tr>
                        <tr>
                            <td>FLUSH</td>
                            <td>5:1</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Perfect Pair</p>
                <p>The additional "Perfect Pair" bet wins if the player's first two cards form a pair of the same rank and suit, the same rank and color, or just the same rank. Payouts are based on the paytable.</p>

                <p>Perfect Pair Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>PERFECT PAIR</td>
                            <td>25:1</td>
                        </tr>
                        <tr>
                            <td>COLORED PAIR</td>
                            <td>12:1</td>
                        </tr>
                        <tr>
                            <td>MIXED PAIR</td>
                            <td>6:1</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Bust Bonus</p>
                <p>This additional bet wins if the dealer busts. The payout depends on the number of cards the dealer busts with. If the player has a Blackjack, the Bust Bonus bet is returned.</p>

                <p>Bust Bonus Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>BUST WITH 8+ CARDS</td>
                            <td>250:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 7 CARDS</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 6 CARDS</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 5 CARDS</td>
                            <td>9:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 4 CARDS</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>BUST WITH 3 CARDS</td>
                            <td>1:1</td>
                        </tr>
                    </tbody>
                </table>

                <p style={{ fontWeight: 700 }}>Crazy 7</p>
                <p>This additional bet wins if the player's first, second, and third cards are sevens. If the player splits sevens and the next card is another seven, they have three sevens. Payouts are based on the paytable.</p>

                <p>Crazy 7 Payout Table</p>
                <table className="rules-table">
                    <tbody>
                        <tr>
                            <td>7-7-7 SUITED</td>
                            <td>2000:1</td>
                        </tr>
                        <tr>
                            <td>7-7-7</td>
                            <td>500:1</td>
                        </tr>
                        <tr>
                            <td>7-7 SUITED</td>
                            <td>150:1</td>
                        </tr>
                        <tr>
                            <td>7-7</td>
                            <td>25:1</td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>5:1</td>
                        </tr>
                    </tbody>
                </table>
            </div>

    },
    {
        id: 4,
        title: 'Place Bets',
        content:
            <div className="rule-content">

                <p>The "BET LIMITS" panel displays the minimum and maximum allowed bet limits at the table, which may change from time to time. Open "Bet Limits" to check your current limits.</p>

                <div className="rule-component">
                    <div className="game-info-inner">
                        <div className="game-info-text">BLACKJACK ONE</div>
                        <div className="game-info-rate">$1 - $1000</div>
                    </div>
                </div>

                <p>To participate in the game, you need to have sufficient funds to cover your bets. Your current BALANCE is displayed on the screen.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text">BALANCE:</div>
                        <div className="balance-value">$1,270</div>
                    </div>
                </div>

                <p>The "CHIP DISPLAY" indicator allows you to select the denomination of each chip you wish to place as a bet. Only those chips that can be covered by your current balance are available for selection.</p>
                <div className="rule-component">
                    <div className="chips-container" style={{ transform: 'scale(0.4)' }}>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                            Clear
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                            Undo
                        </div>

                        <div className="chips-box">
                            {chips.map((chip, index) =>
                                <div key={`${index}`} className="chip">
                                    <Chip color={chip.color} value={chip.value} />
                                </div>
                            )}
                        </div>

                        <div className="chips-button">
                            <span>2x</span>
                            Double
                        </div>

                        <div className="chips-button">
                            <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                            Repeat
                        </div>

                    </div>
                </div>

                <p>After selecting a chip, place a bet by clicking on the corresponding betting area on the game table. Each click increases your bet by the value of the selected chip or up to the maximum allowable limit for your chosen bet type. Once the maximum bet limit is reached, additional funds will not be accepted, and a message will appear above your bet notifying you that the maximum bet has been placed.</p>

                <p>NOTE: Please do not minimize the browser window or open other tabs while the betting period is active and bets are being placed on the table. Such actions may be interpreted as leaving the game, and therefore, your bets will be rejected for that round.</p>

                <p>The "REPEAT" button allows you to repeat all bets from the previous game round. This button remains active until the first chip is placed.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                        Repeat
                    </div>
                </div>

                <p>The "DOUBLE" (2×) button becomes available after a bet is placed. Each click doubles all your bets up to the maximum limit. Please note that you must have sufficient funds in your account to double ALL your placed bets.</p>

                <div className="rule-component">
                    <div className="chips-button">
                        <span>2x</span>
                        Double
                    </div>
                </div>

                <p>The "UNDO" button allows you to remove the last placed bet.</p>
                <p>Clicking the "UNDO" button again removes bets one by one in reverse order. To remove all your bets, hold down the "UNDO" button.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                        Undo
                    </div>
                </div>

                <p>The "CLEAR" button removes all placed bets.</p>
                <div className="rule-component">
                    <div className="chips-button">
                        <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                        Clear
                    </div>
                </div>

                <p>The "TOTAL BET" indicator displays the total amount of bets placed in the current round.</p>
                <div className="rule-component">
                    <div className="balance-box">
                        <div className="balance-text blue">TOTAL BET:</div>
                        <div className="balance-value">$270</div>
                    </div>
                </div>

                <p>Make a decision</p>
                <p>After your cards are dealt, your card combination and a decision window will appear.</p>
                <div className="rule-component">
                    <Picture src={`${env.endpoint}/images/game.png`} alt="Game" />
                </div>

                <p>When clicked, the "Insurance" window will appear.</p>
                <div className="rule-component">
                    <Picture src={`${env.endpoint}/images/insurance.png`} alt="Insurance" />
                </div>

            </div>

    },
    {
        id: 5,
        title: 'Game Number',
        content:
            <div className="rule-content">
                <p>Each game round is identified by a unique GAME NUMBER.</p>
                <div className="rule-component">
                    <p><b>#47489</b></p>
                </div>
                <p>Please use this number (or take a screenshot of the game number) if you wish to contact Support with questions regarding a specific round.</p>
            </div>
    },
    {
        id: 6,
        title: 'Sound',
        content:
            <div className="rule-content">
                <p>The "SOUND" button toggles all game sounds and voices on or off. Please note that changing tables will automatically turn sounds back on.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/music-on.png`} alt="Volume" />
                    </div>
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/volume.png`} alt="Volume" />
                    </div>
                </div>

                <p>You can adjust sound settings by pressing the "SETTINGS" button and selecting the SOUND tab.</p>
            </div>
    },
    {
        id: 7,
        title: 'Game History',
        content:
            <div className="rule-content">
                <p>The "HISTORY" button opens a window displaying all the game rounds you have played and their results.</p>

                <div className="rule-component">
                    <div className="game-control">
                        <Picture src={`${env.mediapoint}/images/history.png`} alt="History" />
                    </div>
                </div>

                <p>The information in the History window is for reference purposes only and may not reflect the final balance due to technical issues.</p>
            </div>
    },
    {
        id: 8,
        title: 'Actions in Case of Malfunction',
        content:
            <div className="rule-content">
                <p>
                    In the event of a game, system, or procedural malfunction, the round will be temporarily
                    suspended, and the game host will notify the service manager. You and other players
                    will see a message in the chat or a pop-up message on the screen informing you that the
                    issue is being addressed. If the manager is able to fix the issue immediately, the game round
                    will resume as normal. If immediate resolution is not possible, the game round will be
                    canceled, and the initial bets will be refunded to all participating players.
                </p>
            </div>
    },
    {
        id: 9,
        title: 'Disconnection Policy',
        content:
            <div className="rule-content">
                <p>
                    If you are disconnected from the game before the betting time expires, any placed bets
                    will be considered invalid and refunded to you. If disconnection occurs after the betting time
                    has expired, placed bets will remain valid and the game will proceed without your participation.
                    You can view the results of the bet in the "History" window after reconnecting.
                </p>
            </div>
    }
]

export const rules = { ru, en }